import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FlashSaleOrderSubmitted, LimitIncreaseApplicationSubmitted, OrderCanceled, OrderSubmitted, PaidInvoicesSuccess } from "@faire/retailer-visitor-shared/events";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { fromPromise_resolve } from "@faire/retailer-visitor-shared/lib/mobxHelpers";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { moneyOrZero } from "@faire/web--source/common/money";
import { MoneyMath } from "@faire/web--source/common/MoneyMath";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import getRetailerCreditSummary from "@faire/web-api--source/api/retailer/retailerToken/credit-summary/get";
import { IRetailerCreditSummary } from "@faire/web-api--source/indigofair/data/IRetailerCreditSummary";
import { action, computed, observable } from "mobx";
import { fromPromise, FULFILLED, REJECTED } from "mobx-utils";
var LimitIncreaseStatus = IRetailerCreditSummary.LimitIncreaseStatus;
/**
 * @deprecated prefer to use `useCreditSummaryStore` or `withStores` instead
 */ export var CreditSummaryStore = /*#__PURE__*/ function() {
    "use strict";
    function CreditSummaryStore() {
        var _this = this;
        _class_call_check(this, CreditSummaryStore);
        this.fetchCreditSummary = function() {
            var retailerToken = RetailerStore.get().retailerToken;
            if (retailerToken === undefined || getIsBrandPreview()) {
                return;
            }
            _this.creditSummaryResult = fromPromise(getRetailerCreditSummary(retailerToken));
            return _this.creditSummaryResult;
        };
        this.setCreditSummary = function(creditSummary) {
            _this.creditSummaryResult = fromPromise_resolve(creditSummary);
        };
        this.subscribeToAppEvents = function() {
            PaidInvoicesSuccess.subscribe(_this.fetchCreditSummary);
            OrderCanceled.subscribe(_this.fetchCreditSummary);
            OrderSubmitted.subscribe(_this.fetchCreditSummary);
            FlashSaleOrderSubmitted.subscribe(_this.fetchCreditSummary);
            LimitIncreaseApplicationSubmitted.subscribe(_this.fetchCreditSummary);
        };
        makeObservable(this);
        this.fetchCreditSummary();
        this.subscribeToAppEvents();
    }
    _create_class(CreditSummaryStore, [
        {
            key: "loaded",
            get: function get() {
                var _this_creditSummaryResult, _this_creditSummaryResult1;
                return ((_this_creditSummaryResult = this.creditSummaryResult) === null || _this_creditSummaryResult === void 0 ? void 0 : _this_creditSummaryResult.state) === FULFILLED || ((_this_creditSummaryResult1 = this.creditSummaryResult) === null || _this_creditSummaryResult1 === void 0 ? void 0 : _this_creditSummaryResult1.state) === REJECTED;
            }
        },
        {
            key: "availableTermsLimit",
            get: function get() {
                var _this_creditSummary;
                return (_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : _this_creditSummary.available_credit;
            }
        },
        {
            key: "totalTermsLimit",
            get: function get() {
                var _this_creditSummary;
                return moneyOrZero((_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : _this_creditSummary.total_credit);
            }
        },
        {
            key: "pastDueInvoicesAmount",
            get: function get() {
                if (this.creditSummary === undefined) {
                    return 0;
                }
                return this.creditSummary.total_past_due_amount_cents;
            }
        },
        {
            key: "limitIncreaseStatus",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return ((_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.status) || IRetailerCreditSummary.LimitIncreaseStatus.NOT_ELIGIBLE;
            }
        },
        {
            key: "lastApplicationAt",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return ((_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.last_application_at) || 0;
            }
        },
        {
            key: "nextApplicationAllowedAt",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return ((_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.next_application_allowed_at) || 0;
            }
        },
        {
            key: "limitIncreaseCents",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return ((_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.on_review_limit_cents) || 0;
            }
        },
        {
            key: "potentialLimit",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return (_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.next_terms_limit;
            }
        },
        {
            key: "nextAvailableLimits",
            get: function get() {
                var _this_creditSummary_limit_increase, _this_creditSummary;
                return (_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : (_this_creditSummary_limit_increase = _this_creditSummary.limit_increase) === null || _this_creditSummary_limit_increase === void 0 ? void 0 : _this_creditSummary_limit_increase.next_available_terms_limits;
            }
        },
        {
            key: "previousLimitCents",
            get: function get() {
                var _this_creditSummary;
                return (_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : _this_creditSummary.previous_terms_limit;
            }
        },
        {
            key: "limitUpdatedAt",
            get: function get() {
                var _this_creditSummary;
                var _this_creditSummary_limit_updated_at;
                return (_this_creditSummary_limit_updated_at = (_this_creditSummary = this.creditSummary) === null || _this_creditSummary === void 0 ? void 0 : _this_creditSummary.limit_updated_at) !== null && _this_creditSummary_limit_updated_at !== void 0 ? _this_creditSummary_limit_updated_at : 0;
            }
        },
        {
            key: "availableCreditsIsPositive",
            get: function get() {
                return MoneyMath.greaterThanZero(moneyOrZero(this.availableTermsLimit));
            }
        },
        {
            key: "creditSummaryPending",
            get: function get() {
                return this.creditSummaryResult === undefined || this.creditSummaryResult.state === "pending";
            }
        },
        {
            key: "creditSummary",
            get: function get() {
                var _this_creditSummaryResult;
                return (_this_creditSummaryResult = this.creditSummaryResult) === null || _this_creditSummaryResult === void 0 ? void 0 : _this_creditSummaryResult.case({
                    fulfilled: function(r) {
                        return r;
                    }
                });
            }
        },
        {
            key: "eligibleForLimitIncrease",
            get: function get() {
                return this.limitIncreaseStatus !== LimitIncreaseStatus.NOT_ELIGIBLE;
            }
        }
    ]);
    return CreditSummaryStore;
}();
CreditSummaryStore.get = singletonGetter(CreditSummaryStore);
__decorate([
    observable
], CreditSummaryStore.prototype, "creditSummaryResult", void 0);
__decorate([
    computed
], CreditSummaryStore.prototype, "loaded", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "availableTermsLimit", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "totalTermsLimit", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "pastDueInvoicesAmount", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "limitIncreaseStatus", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "lastApplicationAt", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "nextApplicationAllowedAt", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "limitIncreaseCents", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "potentialLimit", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "nextAvailableLimits", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "previousLimitCents", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "limitUpdatedAt", null);
__decorate([
    computed
], CreditSummaryStore.prototype, "availableCreditsIsPositive", null);
__decorate([
    action
], CreditSummaryStore.prototype, "fetchCreditSummary", void 0);
__decorate([
    action
], CreditSummaryStore.prototype, "setCreditSummary", void 0);
export var useCreditSummaryStore = createStoreHook(CreditSummaryStore);
